/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=6c66f4e2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6c66f4e2&lang=scss"

import exportComponent from "/Users/yaogengzhu/Documents/soft-open/software-platform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__